import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class SaddlerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SADDLER;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 farmu
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);

		if (!this.suppliesTileIndexes.size && !this.showConsumptionInfo) {
			for (const resource of consumption.keys()) {
				if (
					[
						ResourceType.FOOD_CONSUMPTION,
						ResourceType.POPULATION_CONSUMPTION,
					].includes(resource)
				)
					continue;

				// consumption.delete(resource);
				consumption.set(resource, 0); // Chceme zobrazovat nulove hodnoty v tile detail.
			}
		}

		return consumption;
	}
}

export default SaddlerBuildingTileEntity;
